import { getRelativePath } from "base/shared/Utils";
import { locale } from "base/shared/Localization";

export const SEO_LANDING_PATHS = {
  ABOUT_BADI: {
    ES: "/sobre-badi",
    EN: "/about-badi",
  },
};

export const getHomePath = ({ source = "" } = {}) => {
  const path = getRelativePath("/");

  return source ? `${path}?source=${encodeURI(source)}` : path;
};

export const getRegisterPath = () => {
  return getRelativePath("/register");
};

export const getAboutBadiPath = () =>
  getRelativePath(
    locale() === "es"
      ? SEO_LANDING_PATHS.ABOUT_BADI.ES
      : SEO_LANDING_PATHS.ABOUT_BADI.EN,
  );
